import React, { useContext } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../App.js'
import { List, ListItem, ListItemText, Divider, makeStyles } from '@material-ui/core'
import './index.css'
import { ReactComponent as Gear } from '../../assets/gear.svg'
import { ReactComponent as Users } from '../../assets/users.svg'
import { ReactComponent as History } from '../../assets/history.svg'
import { ReactComponent as  KeksReport } from '../../assets/keks_report.svg'
import { ReactComponent as Report } from '../../assets/report.svg'
import { ReactComponent as Signout } from '../../assets/signout.svg'
import { ReactComponent as Arrow } from '../../assets/arrow.svg'
import COLORS from '../../colors'

const useStyles = makeStyles((theme) => ({
	menuBtn: {
		textDecoration:'none',
		color: COLORS.blue
	}
}))

const Menu = ({cid, rank}) => {

  const { signOut, adminArticles, adminCashiers, transactionHistory, transactionsReport, setPageNumber } = useContext(AuthContext);
  const params = useParams()
  const classes = useStyles()
  const navigate = useNavigate()

  const handleSignout = () => {
	  		signOut(cid)
		  	//setTimeout(()=>window.location.replace(`/kekspos/?cid=${cid}`), 0)
			  setTimeout(()=>navigate(`/kekspos/`), 0)
  }
  
  return (
    <div className="menu">
	<List component="nav">
		<Divider style={{width:'100%'}}/>
  		{rank>0&&<ListItem 	component={Link} 
		  					to={`/kekspos/${params.tid}/admin-artikl`} 
							className={classes.menuBtn} 
							button 
							onClick={() => adminArticles()}>
  		        				<Gear />
    							<ListItemText primary="Upravljanje artiklima" />
    							<Arrow/>
  				</ListItem>}
		{rank>0&&<Divider style={{width:'100%'}}/>}
  		{rank>0&&<ListItem 	component={Link} 
		  					to={`/kekspos/${params.tid}/admin-korisnik`} 
							className={classes.menuBtn} 
							button 
							onClick={() => adminCashiers()}>
  		        				<Users />
    							<ListItemText primary="Upravljanje korisnicima" />
    							<Arrow />
  		</ListItem>}
		{rank>0&& <Divider style={{width:'100%'}}/>}
  		<ListItem 	component={Link} 
		  			to={`/kekspos/${params.tid}/povijest-transakcija`} 
					className={classes.menuBtn} 
					button 
					onClick={() => transactionHistory()}>
  		        			<History />
    						<ListItemText primary="Povijest transakcija" />
    						<Arrow />
  		</ListItem>
		<Divider style={{width:'100%'}}/>
  		<ListItem 	component={Link} 
		  			to={`/kekspos/${params.tid}/izvjestaji`} 
					className={classes.menuBtn} 
					button 
					onClick={() => transactionsReport()}>
  		        			<KeksReport />
    						<ListItemText primary="Izvještaji" />
    						<Arrow />
  		</ListItem>
		<Divider style={{width:'100%'}}/>
		<ListItem 	component={Link} 
					to={`/kekspos/${params.tid}/uvjeti-koristenja`} 
					className={classes.menuBtn} 
					button 
					onClick={() => setPageNumber(15)}>
  		        			<Report />
    						<ListItemText primary="Uvjeti korištenja" />
    						<Arrow />
  		</ListItem>
		<Divider style={{width:'100%'}}/>
  		<ListItem 	component={Link} 
		  			to={`/kekspos/`} 
					className={classes.menuBtn} 
					button 
					onClick={() => handleSignout()}>
  		        			<Signout />
    						<ListItemText primary="Odjava" />
    						<Arrow />
  		</ListItem>
		<Divider style={{width:'100%'}}/>
	</List>
    </div>
  )
}

export default Menu
